import { useState } from "react";
import Styles from "./main.module.css";
export const Navigator = ( props ) => {
    const { page } = props;
    const { Navigator } = Styles;
    const listArray = [
        { icon: <i className="bi bi-house-door-fill"></i>,      pageName: "Home",       theme: "#9C27B0", link: "/home" },
        { icon: <i className="bi bi-newspaper"></i>,            pageName: "Blogs",      theme: "#3F51B5", link: "/blogs" },
        { icon: <i className="bi bi-camera-reels-fill"></i>,    pageName: "Shorts",     theme: "#2196F3", link: "/shorts" },
        { icon: <i className="bi bi-collection-play-fill"></i>, pageName: "Courses",    theme: "#00BCD4", link: "/courses" },
        { icon: <i className="bi bi-grid-fill"></i>,            pageName: "Products",   theme: "#009688", link: "/products" },
        { icon: <i className="bi bi-briefcase-fill"></i>,       pageName: "Projects",   theme: "#4caf50", link: "/projects" },
        { icon: <i className="bi bi-backpack4-fill"></i>,       pageName: "Media",      theme: "#cddc39", link: "/media" },
        { icon: <i className="bi bi-person-vcard-fill"></i>,    pageName: "About Us",   theme: "#ff9800", link: "/about_us" },
        { icon: <i className="bi bi-diagram-3-fill"></i>,       pageName: "Contact Us", theme: "#ff5722", link: "/contact_us" },
        { icon: <i className="bi bi-stars"></i>,                pageName: "Gemini",     theme: "#795548", link: "/gemini" },
    ];
    return (
        <nav className={ Navigator }>
            {
                listArray.map(( value, key ) => {
                    const { link, icon, theme, pageName } = value;
                    return <a style={{ color: theme ? theme : "white", opacity: page === pageName ? "1" : "0.3" }} href={ link && link } key={ key }>{ icon }</a>
                })
            }
        </nav>
    );
};